import Avatar from './Avatar'
import UserAvatar from './UserAvatar'

export default Avatar

export {
    UserAvatar
}